/*eslint-disable */
export const emailValidationRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}))$/;
/*eslint-enable */

export const priceInputRegex = /^(\d{1,3}(\.\d{3})+(,\d{0,2})?|\d+([.,]\d{0,2})?)$/; // accepts the backend's de_DE price format (1.234,50) and plain 1234.50, including every state while typing
